module.exports = __webpack_public_path__ + "img/85.7066832b.jpg";